import React from 'react';
import { useForm } from 'react-hook-form';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowAltCircleRight, faRedoAlt, faTimes } from '@fortawesome/free-solid-svg-icons';

//utils
import { hasText } from './../../../utils/utils';

//services
import serviceUsuarios from './../../../services/usuarios';

//redux
import { actions as actionsSite } from './../../../redux/actions/site';
import { actions as actionsAuth } from './../../../redux/actions/auth';
import { useDispatch } from 'react-redux';

const Ativacao = () => {
    const dispatch = useDispatch();
    const { register, handleSubmit, errors } = useForm();

    const reenviarCodigo = async () => {
        dispatch(actionsSite.setLoadingMsg("Solicitando novo código..."));
        const res = await serviceUsuarios.reenviarCodigo();
        if (!res.erro) {
            dispatch(actionsSite.setLoadingMsg("Código enviado com sucesso, verifique seu E-mail ou SMS"));
            setTimeout(() => {
                dispatch(actionsSite.setLoadingMsg(""));
            }, 3000);
        } else {
            dispatch(actionsSite.setLoadingMsg(res.msg));
            setTimeout(() => {
                dispatch(actionsSite.setLoadingMsg(""));
            }, 3000);
        }
    }

    const ativar = async data => {
        dispatch(actionsSite.setLoadingMsg("Ativando conta..."));
        const res = await serviceUsuarios.ativarConta(data);
        dispatch(actionsSite.setLoadingMsg(res.msg));
        if (!res.erro) {
            await dispatch(actionsAuth.setProfileByToken());
        }
        setTimeout(async () => {
            dispatch(actionsSite.setLoadingMsg(""));
        }, 3000);

    }

    return (
        <div className="form">
            <form className="formModule branco" onSubmit={handleSubmit(ativar)}>
                <h3 className="tituloEtapa">2ª Etapa - Ativação da conta</h3>
                <div className="break"></div>
                <div className="info">
                    Digite o código de ativação que enviamos via e-mail / sms
                    </div>
                <div className="break"></div>
                <div className={errors.codigo ? "field error codigo" : "field codigo"}>
                    <input name="codigo" id="codigo" maxLength={6} onKeyUp={(e) => hasText(e)} type="text" ref={register({ required: true, minLength: 6, validate: { isNumeric: value => !isNaN(value) } })} />
                    <label htmlFor="codigo">Código de ativação</label>
                </div>


                <div className="acoes">
                    <button type="submit" className="salvar"><FontAwesomeIcon icon={faArrowAltCircleRight} /> Ativar conta</button>
                    <button type="button" className="reenviar" onClick={() => reenviarCodigo()}><FontAwesomeIcon icon={faRedoAlt} /> Reenviar código</button>
                    {/* <button type="button" className="cancelar" onClick={() => history.push('/painel/catalogos')}><FontAwesomeIcon icon={faBan} /> Cancelar</button> */}
                </div>
            </form>
            {errors && Object.keys(errors).length > 0 &&
                <div className="erros">
                    {errors.codigo?.type === 'required' && <div><FontAwesomeIcon icon={faTimes} /> Preencha o código de ativação</div>}
                    {errors.codigo?.type === 'minLength' && <div><FontAwesomeIcon icon={faTimes} /> O código precisa ter pelo menos 6 caracteres</div>}
                    {errors.codigo?.type === 'isNumeric' && <div><FontAwesomeIcon icon={faTimes} /> Preencha o código com apenas números</div>}
                </div>
            }
        </div>
    );
};

export default Ativacao;